import { render, staticRenderFns } from "./BwaTreeview.vue?vue&type=template&id=67ccc143&scoped=true"
import script from "./BwaTreeview.vue?vue&type=script&lang=js"
export * from "./BwaTreeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ccc143",
  null
  
)

export default component.exports